module.exports = __webpack_public_path__ + "img/icon-ig.ca42d47c.svg";